import { render, staticRenderFns } from "./TheNavBarListGroupItem.vue?vue&type=template&id=80d8ad40&scoped=true&"
import script from "./TheNavBarListGroupItem.vue?vue&type=script&lang=js&"
export * from "./TheNavBarListGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./TheNavBarListGroupItem.vue?vue&type=style&index=0&id=80d8ad40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d8ad40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItem,VListItemContent,VListItemTitle})
